import { render, staticRenderFns } from "./AccountsPayableSplitModal.vue?vue&type=template&id=4c2bf72f&scoped=true&"
import script from "./AccountsPayableSplitModal.vue?vue&type=script&lang=js&"
export * from "./AccountsPayableSplitModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2bf72f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c2bf72f')) {
      api.createRecord('4c2bf72f', component.options)
    } else {
      api.reload('4c2bf72f', component.options)
    }
    module.hot.accept("./AccountsPayableSplitModal.vue?vue&type=template&id=4c2bf72f&scoped=true&", function () {
      api.rerender('4c2bf72f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/financial/accounts-payable/components/AccountsPayableSplitModal.vue"
export default component.exports